export const getAddressList = (ids, masterList) => {
    if (typeof ids == 'undefined' || ids == null) {
        return [];
    }

    let addresses = {};

    if (Array.isArray(ids)) {
        ids.forEach((id) => {
            const address = getFullAddressInfo(id, masterList);
            if (address) {
                addresses[id] = address;
            }
        });
    }
    else {
        Object.keys(ids).forEach((id) => {
            addresses[id] = getFullAddressInfo(id, masterList);
        });
    }

    return Object.values(addresses);
};
export const getFullAddressInfo = (id, masterList) => {
    return masterList[id] || false;
};
export const buildAddressParams = (data) => {
    let newParams = {};
    const allowedKeys = [
        'BusinessName',
        'StreetNumber',
        'StreetName',
        'StreetSuffix',
        'Suburb',
        'State',
        'PostalCode',
        'Country',
        'Phone',
    ];

    allowedKeys.map((allowedKey) => {
        if (typeof data[allowedKey] != 'undefined') {
            newParams[allowedKey] = data[allowedKey];
        }
    });

    return newParams;
};
export const buildUpdateAddressParams = (data) => {
    let newParams = {};
    const allowedKeys = [
        'ID',
        'BusinessName',
        'StreetNumber',
        'StreetName',
        'StreetSuffix',
        'Suburb',
        'State',
        'PostalCode',
        'Country',
        'Phone',
    ];

    allowedKeys.map((allowedKey) => {
        if (typeof data[allowedKey] != 'undefined') {
            newParams[allowedKey] = data[allowedKey];
        }
    });

    return newParams;
};
export const printAddressNicely = (data) => {
    let addressBuilder = [];
    let tmpStateKeys = [];
    const allowedKeys1 = [
        'BusinessName',
        'StreetNumber',
        'StreetName',
        'StreetSuffix',
        'Suburb',
    ];
    const allowedStatePostalKeys = ['State', 'PostalCode'];
    const allowedKeys2 = ['Country'];

    if (!data || (data.ID != undefined && data.ID == 0)) {
        return '';
    }

    // Address etc
    allowedKeys1.forEach((allowedKey) => {
        if (
            typeof data[allowedKey] != 'undefined' &&
            data[allowedKey] != null &&
            data[allowedKey] != ''
        ) {
            addressBuilder.push(data[allowedKey]);
        }
    });

    // State Postcode
    allowedStatePostalKeys.forEach((allowedKey) => {
        if (
            typeof data[allowedKey] != 'undefined' &&
            data[allowedKey] != null &&
            data[allowedKey] != ''
        ) {
            tmpStateKeys.push(data[allowedKey]);
        }
    });

    if (tmpStateKeys.length > 0) {
        addressBuilder.push(tmpStateKeys.join(' '));
    }

    // Country
    allowedKeys2.forEach((allowedKey) => {
        if (
            typeof data[allowedKey] != 'undefined' &&
            data[allowedKey] != null &&
            data[allowedKey] != ''
        ) {
            addressBuilder.push(data[allowedKey]);
        }
    });

    return addressBuilder.join('<br />');
};
